module.exports = __webpack_public_path__ + "9e869fee02511ad200f8f5cfb3602d8e.svg";